import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Rating } from '../types';

interface RatingsState {
  byPhotoId: Record<number, Record<number, Rating>>;
  loading: boolean;
  error: string | null;
}

const initialState: RatingsState = {
  byPhotoId: {},
  loading: false,
  error: null,
};

const ratingsSlice = createSlice({
  name: 'ratings',
  initialState,
  reducers: {
    setRatingsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setRatingsByPhoto: (state, action: PayloadAction<{ photoId: number; ratings: Rating[] }>) => {
      const { photoId, ratings } = action.payload;
      state.byPhotoId[photoId] = {};
      ratings.forEach((rating) => {
        state.byPhotoId[photoId][rating.user_id] = rating;
      });
    },
    upsertRating: (state, action: PayloadAction<Rating>) => {
      const rating = action.payload;
      if (!state.byPhotoId[rating.photo_id]) {
        state.byPhotoId[rating.photo_id] = {};
      }
      state.byPhotoId[rating.photo_id][rating.user_id] = rating;
    },
    deleteRating: (state, action: PayloadAction<{ photoId: number; userId: number }>) => {
      const { photoId, userId } = action.payload;
      if (state.byPhotoId[photoId]) {
        delete state.byPhotoId[photoId][userId];
      }
    },
    clearRatings: (state) => {
      state.byPhotoId = {};
    },
  },
});

export const {
  setRatingsLoading,
  setRatingsByPhoto,
  upsertRating,
  deleteRating,
  clearRatings,
} = ratingsSlice.actions;

export default ratingsSlice.reducer;
